// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('concept.management', {
    url: '/management',
    templateUrl: 'main/concept/management/management.tpl.html',
    controller: 'ConceptManagementController as vm',
  });
};

class ConceptManagementController {
  constructor($rootScope, $scope, concept) {
    'ngInject';
    $rootScope.pageTitle = `${concept.name || ''} - Management`;

    this.concept = concept;
  }
}

angular
  .module('main.concept.management', [])
  .config(config)
  .controller('ConceptManagementController', ConceptManagementController);
